<template>
  <div class="bar_wrap">
    <div ref="barcharts" id="barcharts" class="barcharts"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
var labelColor = []
var option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  // dataZoom: [{
  //   type: 'slider',
  //   show: true,
  //   xAxisIndex: [0],
  //   left: '9%',
  //   bottom: -5,
  //   start: 10,
  //   end: 90 //初始化滚动条
  // }],
  xAxis: [
    {
      type: 'category',
      data: [],
      axisPointer: {
        type: 'shadow'
      },
      axisLabel: {//坐标轴刻度标签的相关设置。
        interval: 0,
        rotate: "45",
        formatter: function (params) {
          var newParamsName = "";// 最终拼接成的字符串
          var paramsNameNumber = params.length;// 实际标签的个数
          var provideNumber = 10;// 每行能显示的字的个数
          var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
          /**
           * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
           */
          // 条件等同于rowNumber>1
          if (paramsNameNumber > provideNumber) {
            /** 循环每一行,p表示行 */
            for (var p = 0; p < rowNumber; p++) {
              var tempStr = "";// 表示每一次截取的字符串
              var start = p * provideNumber;// 开始截取的位置
              var end = start + provideNumber;// 结束截取的位置
              // 此处特殊处理最后一行的索引值
              if (p == rowNumber - 1) {
                // 最后一次不换行
                tempStr = params.substring(start, paramsNameNumber);
              } else {
                // 每一次拼接字符串并换行
                tempStr = params.substring(start, end) + "\n";
              }
              newParamsName += tempStr;// 最终拼成的字符串
            }

          } else {
            // 将旧标签的值赋给新标签
            newParamsName = params;
          }
          //将最终的字符串返回
          return newParamsName
        },
        color: function (k) {

          return color[k]
        },
        color: function (param, index) {
          let color = labelColor;
          return color[index]
        },
      },
    }
  ],
  yAxis: {
    type: 'value',
    min: -100,
    max: 100,
    interval: 20,
  },
  series: [
    {
      type: "bar",
      barMaxWidth: 25,
      radius: '100%',
      data: [],
      itemStyle: {//柱体背景色
        normal: {
          color: (val) => {
            var index_color = val.value;
            return index_color <= 20 && index_color >= -20 ? "#9ef133" : index_color >= 21 && index_color <= 100 ? "#f1be33" : "#3195e6";
          },
        },
      }
    },
  ],
};

export default {
  props: {
    barlist: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
    }
  },
  watch: {
    barlist (curVal, oldVal) {
      this.initCharts()
    },
  },
  methods: {
    initCharts () {
      let listArr = []
      let textArr = []
      if (this.$route.name == 'contrast') {
        this.barlist.forEach((item) => {
          listArr.push(item.marks)
          textArr.push(item.created_at)
        })
      } else {
        this.barlist.forEach((item) => {
          listArr.push(item.value)
          textArr.push(item.name)
        })
      }
      this.handlabelColor()
      let charts = this.$echarts.init(this.$refs.barcharts);
      option.xAxis[0].data = textArr
      option.series[0].data = listArr.map((item) => {
        // 循环 
        return {
          value: item,
          label: {
            show: true, //开启显示
            position: item > 0 ? "top" : "bottom", //判断正负值上方显示还是下方
            formatter: "{c}",//单位
            textStyle: {
              //数值样式
              color: item <= 20 && item >= -20 ? "#9ef133" : item >= 21 && item <= 100 ? "#f1be33" : "#3195e6",
              fontSize: "18px",
            },
          },
        };
      }),
        charts.setOption(option);

    },
    handlabelColor () {
      labelColor = []
      console.log(this.barlist)
      this.barlist.forEach((item) => {
        if (item.name == this.$route.query.item) {
          labelColor.push('rgb(46, 148, 229)')
        } else {
          labelColor.push('#000')
        }
      })
    }
  },
  created () {
    this.$nextTick(() => {
      this.initCharts()
    })
  }
}
</script>
<style lang="scss" scoped>
.barcharts {
  width: 700px;
  height: 610px;
}
</style>